import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { CityOutputDto, CityService } from 'src/generated_client';

@Component({
  selector: 'app-city-management',
  templateUrl: './city-management.component.html',
  styleUrls: ['./city-management.component.css']
})

export class CityManagementComponent implements OnInit {

  displayedColumns: string[] = ['name', 'status', 'option'];
  allCities: CityOutputDto[] = [];

  constructor(
    private router: Router,
    private cityService: CityService,
    private snackBar: SnackBarService,
  ) { }

  ngOnInit() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.cityService.apiCityGetAllCitiesGet().subscribe(x => {
      this.allCities = x;
    });
  }

  changeCityStatus(id: number, status: boolean, name: string) {
    if (status) {
      this.cityService.apiCityDisableCityPut(id).subscribe(response => {
        this.router.navigate(['city-management']);
        this.snackBar.openSnackBar('Se desactivó correctamente','Aceptar')
      },
        (err) => {
          this.snackBar.openSnackBar(err.error.error, 'Aceptar');
        })
    }
    else {
      this.cityService.apiCityEnableCityPut(id).subscribe(response => {
        this.router.navigate(['city-management']);
        this.snackBar.openSnackBar('Se activó correctamente','Aceptar')
      },
        (err) => {
          this.snackBar.openSnackBar(err.error.error, 'Aceptar');
        })
    }
  }

  editCity(id: number) {
    this.router.navigate(['edit-city', id]);
  }

  addCity() {
    this.router.navigate(['add-city']);
  }

  deleteCity(id: number) {

    this.cityService.apiCityDeleteCityDelete(id).subscribe(response => {

      this.router.navigate(['city-management']);
    },
      (err) => {
        this.snackBar.openSnackBar(err.error.error, 'Aceptar');
      })
  }
}
